import type {
  TopArticlesNotLazyBlockVM,
  ITopArticlesLazyBlockPresenter,
} from '@jtnews/shared/seedwork/frontend/application';
import { TopArticlesBlockUseCaseError } from '@jtnews/shared/seedwork/frontend/application';

import type { TopArticlesBlockLazyDTO } from './top-articles-block.dto';
import { TopArticlesBlockPresenter } from './top-articles-block.presenter';
import type { TopArticlesBlockPresenterConfig } from './top-articles-block.presenter';

type TopArticlesLazyBlockPresenterConfig = TopArticlesBlockPresenterConfig;

type TopArticlesLazyBlockPresenterInput = {
  data: TopArticlesBlockLazyDTO;
  params: null;
};

export class TopArticlesLazyBlockPresenter
  extends TopArticlesBlockPresenter<TopArticlesNotLazyBlockVM, TopArticlesBlockLazyDTO>
  implements ITopArticlesLazyBlockPresenter<TopArticlesBlockLazyDTO>
{
  constructor(config: TopArticlesLazyBlockPresenterConfig) {
    super(config);
  }

  present(input: TopArticlesLazyBlockPresenterInput): TopArticlesNotLazyBlockVM {
    try {
      const {
        data: { type, data, params, reach_goal: reachGoal },
      } = input;

      return {
        type,
        isLazy: false,
        params,
        meta: null,
        reachGoal: this.presentReachGoals(reachGoal),
        data: data.map((item) => this.presentTopArticle(item)),
      };
    } catch (err) {
      throw TopArticlesBlockUseCaseError.of('Не удалось выполнить present', err as Error);
    }
  }
}
